

// ====================================================================
// TABS JS 
// ====================================================================

function openCity(evt, cityName, buttonElement) {
    var tabGroup = buttonElement.closest(".tab-group");

    var tabcontent = tabGroup.querySelectorAll(".tabcontent");
    tabcontent.forEach(content => {
        content.classList.remove("active");
        content.style.display = "none";
    });

    var tablinks = tabGroup.querySelectorAll(".tablinks");
    tablinks.forEach(link => {
        link.classList.remove("active");
    });

    var currentTab = document.getElementById(cityName);
    if (currentTab) {
        const overlay = document.createElement('div');
        overlay.classList.add('tab-overlay');
        currentTab.appendChild(overlay);
        currentTab.style.display = "block";

        setTimeout(() => {
            overlay.remove();
            requestAnimationFrame(() => {
                currentTab.classList.add("active");
            });
        }, 400);
    }

    if (evt && evt.currentTarget) {
        evt.currentTarget.classList.add("active");
    }
}

document.addEventListener("DOMContentLoaded", () => {
    document.getElementById("defaultOpen1")?.click();
    document.getElementById("defaultOpen2")?.click();
    document.getElementById("defaultOpen3")?.click();
});




// ====================================================================
// MODEL JS 
// ====================================================================

function openModal(modalId) {
    var $modal = $("#" + modalId);
    var $content = $modal.find(".modal-contents");
    $modal.css("display", "block");
    var viewportHeight = $(window).height();
    var viewportWidth = $(window).width();
    var contentHeight = $content.outerHeight();
    var contentWidth = $content.outerWidth();
    var topPosition = (viewportHeight - contentHeight) / 2;
    var leftPosition = (viewportWidth - contentWidth) / 2;
    $content.css({
        position: "absolute",
        top: "0px",
        left: leftPosition + "px",
        opacity: 0,
    });

    setTimeout(function () {
        $content.css({
            transition: "top 0.5s, opacity 0.5s",
            top: topPosition + "px",
            opacity: 1,
        });
    }, 10);
}

function closeModal(modalId) {
    var $modal = $("#" + modalId);
    var $content = $modal.find(".modal-contents");

    $content.css({
        transition: "top 0.5s, opacity 0.5s",
        opacity: 0,
        top: "0px",
    });

    setTimeout(function () {
        $modal.css("display", "none");
    }, 500);
}

$(document).ready(function () {
    // When any <a> with href="#modalId" is clicked
    $("a[href^='#']:not([href='#'])").on("click", function (event) {
        event.preventDefault(); // Prevent default jump behavior
        var modalId = $(this).attr("href").substring(1); // Get modal ID from href
        openModal(modalId);
    });

    // Close modal when clicking outside the content
    $(window).on("click", function (event) {
        $(".styles-modal").each(function () {
            var $modal = $(this);
            if ($(event.target).is($modal)) {
                closeModal($modal.attr("id"));
            }
        });
    });
});

$(document).ready(function () {
    // Custom close button
    $(".close-btns").on("click", function () {
        var $modal = $(this).closest(".styles-modal");
        stopIframeVideo($modal);
    });

    // Click outside to close
    $(window).on("click", function (event) {
        $(".styles-modal").each(function () {
            var $modal = $(this);
            if ($(event.target).is($modal)) {
                stopIframeVideo($modal);
            }
        });
    });

    function stopIframeVideo($modal) {
        $modal.find("iframe").each(function () {
            var $iframe = $(this);
            var src = $iframe.attr("src");
            $iframe.attr("src", ""); // Remove src to stop video
            setTimeout(function () {
                $iframe.attr("src", src); // Optional: restore after modal is closed
            }, 500); // Restore after modal animation completes
        });
    }
});

// ====================================================================
// SLIDER JS 
// ====================================================================

jQuery(document).ready(function ($) {
    var slideCount = $('.top-bar-slider .item').length;
    $('.top-bar-slider').owlCarousel({
        loop: slideCount > 1, // loop only if more than 1
        margin: 10,
        nav: slideCount > 1,  // show arrows only if more than 1
        dots: false,
        autoplay: slideCount > 1,
        smartSpeed: 1000,
        autoplayTimeout: 2000,
        responsive: {
            0: { items: 1 },
            600: { items: 1 },
            1000: { items: 1 }
        }
    });
});


// ==== Generic OwlCarousel Initializer ====
function initOwlSlider($context, selector, settings) {
  var $slider = $context.find(selector);

  if ($slider.length) {
    if ($slider.hasClass('owl-loaded')) {
      $slider.trigger('destroy.owl.carousel');
      $slider.removeClass('owl-loaded');
      $slider.find('.owl-stage-outer').children().unwrap();
    }
    $slider.owlCarousel(settings);
  }
}

// ==== Slider Configurations ====
var sliderConfigs = {
  '.shop-slider': {
    loop: true,
    margin: 17,
    nav: true,
    dots: false,
    autoplay: true,
    stagePadding: 150,
    smartSpeed: 2000,
    autoplayTimeout: 4000,
    responsive: {
      0: { stagePadding: 20, items: 2 },
      600: { stagePadding: 50, items: 3 },
      1000: { items: 6 }
    }
  },
  '.categories-slider': {
    loop: true,
    margin: 24,
    nav: true,
    dots: false,
    autoplay: false,
    smartSpeed: 1000,
    autoplayTimeout: 7000,
    responsive: {
      0: { items: 2, margin: 21 },
      600: { items: 4 },
      1000: { items: 6 }
    }
  },
  '.testimonial-slider': {
    loop: true,
    margin: 24,
    nav: true,
    dots: false,
    autoplay: false,
    smartSpeed: 1000,
    autoplayTimeout: 6000,
    responsive: {
      0: { items: 1, margin: 21 },
      600: { items: 2 },
      1000: { items: 3 }
    }
  },
  '.banner-slider': {
    loop: true,
    margin: 10,
    nav: false,
    dots: true,
    autoplay: true,
    smartSpeed: 1000,
    autoplayTimeout: 7000,
    responsive: {
        0: {
            items: 1
        },
        600: {
            items: 1
        },
        1000: {
            items: 1
        }
    }
  },
  '.arrival-slider': {
    loop: true,
    margin: 24,
    nav: true,
    dots: false,
    autoplay: false,
    smartSpeed: 1000,
    autoplayTimeout: 7000,
    responsive: {
        0: {
            items: 2,
            margin: 16
        },
        600: {
            items: 3
        },
        1000: {
            items: 4
        }
    }
  },
};

// ==== Run on Page Load ====
$(document).ready(function () {
  Object.keys(sliderConfigs).forEach(function (selector) {
    initOwlSlider($(document), selector, sliderConfigs[selector]);
  });
});


// ==== Shopify Theme Editor Events ====
document.addEventListener('shopify:section:load', function (e) {
  var $section = $(e.target);
  Object.keys(sliderConfigs).forEach(function (selector) {
    initOwlSlider($section, selector, sliderConfigs[selector]);
  });
});

document.addEventListener('shopify:section:unload', function (e) {
  var $slider = $(e.target).find('.owl-carousel');
  if ($slider.hasClass('owl-loaded')) {
    $slider.trigger('destroy.owl.carousel');
  }
});

document.addEventListener('shopify:block:select', function (e) {
  var $block = $(e.target);
  Object.keys(sliderConfigs).forEach(function (selector) {
    if ($block.closest(selector).length) {
      initOwlSlider($(document), selector, sliderConfigs[selector]);
    }
  });
});

document.addEventListener('shopify:block:deselect', function (e) {
  var $block = $(e.target);
  Object.keys(sliderConfigs).forEach(function (selector) {
    if ($block.closest(selector).length) {
      initOwlSlider($(document), selector, sliderConfigs[selector]);
    }
  });
});



// ====================================================================
// ACCORDIAN JS 
// ====================================================================
(function () {
    document.querySelectorAll(".accordion-container").forEach(container => {
        const accordions = container.querySelectorAll(".accordions");

        if (accordions[0]) {
            accordions[0].classList.add("active");
            accordions[0].nextElementSibling.style.maxHeight = accordions[0].nextElementSibling.scrollHeight + "px";
        }

        accordions.forEach(accordion => {
            accordion.addEventListener("click", () => {
                const isActive = accordion.classList.contains("active");
                accordions.forEach(acc => {
                    acc.classList.remove("active");
                    acc.nextElementSibling.style.maxHeight = null;
                });
                if (!isActive) {
                    accordion.classList.add("active");
                    accordion.nextElementSibling.style.maxHeight = accordion.nextElementSibling.scrollHeight + "px";
                }
            });
        });
    });
})();




// ====================================================================
// OFFCANVA JS 
// ====================================================================
const menu = document.querySelector(".menu");
const goBack = menu.querySelector(".go-back");
const menuTrigger = document.querySelector(".mobile-menu-trigger");
const closeMenu = menu.querySelector(".mobile-menu-close");
let menuStack = []; // Track submenu levels

// Attach event listener to all menu-main elements
const menuMains = menu.querySelectorAll(".menu-main");

menuMains.forEach(menuMain => {
    menuMain.addEventListener("click", (e) => {
        if (!menu.classList.contains("active")) return;

        const trigger = e.target.closest(".submenu-icon, .menu-item-has-children > a[href='#']");
        if (!trigger || !menuMain.contains(trigger)) return;

        const hasChildren = trigger.closest(".menu-item-has-children");
        const directSubMenu = Array.from(hasChildren.children).find(child => child.classList.contains("sub-menu"));

        if (directSubMenu) {
            e.preventDefault();
            e.stopPropagation();
            showSubMenu(hasChildren, directSubMenu);
        }
    });
});

// Go back one level
goBack.addEventListener("click", () => {
    hideSubMenu();
});

// Open/close menu
menuTrigger.addEventListener("click", () => {
    toggleMenu();
});
closeMenu.addEventListener("click", () => {
    toggleMenu();
});
document.querySelector(".menu-overlay").addEventListener("click", () => {
    toggleMenu();
});

function toggleMenu() {
    menu.classList.toggle("active");
    document.querySelector(".menu-overlay").classList.toggle("active");
}

// ✅ FIXED showSubMenu function
function showSubMenu(hasChildren, directSubMenu) {
    const newSubMenu = directSubMenu || Array.from(hasChildren.children).find(child => child.classList.contains("sub-menu"));
    if (!newSubMenu) return;
    newSubMenu.classList.add("active");
    newSubMenu.style.animation = "slideLeft 0.5s ease forwards";

    const menuTitle = hasChildren.querySelector("a").textContent;
    menuStack.push({ subMenu: newSubMenu, title: menuTitle });

    menu.querySelector(".current-menu-title").innerHTML = menuTitle;
    menu.querySelector(".mobile-menu-head").classList.add("active");
}

// ✅ FIXED hideSubMenu function
function hideSubMenu() {
    const currentMenu = menuStack[menuStack.length - 1]; // Peek

    if (currentMenu) {
        currentMenu.subMenu.style.animation = "slideRight 0.5s ease forwards";

        setTimeout(() => {
            currentMenu.subMenu.classList.remove("active");
            menuStack.pop(); // Remove after animation

            if (menuStack.length > 0) {
                const previousMenu = menuStack[menuStack.length - 1];
                menu.querySelector(".current-menu-title").innerHTML = previousMenu.title;
            } else {
                menu.querySelector(".current-menu-title").innerHTML = "";
                menu.querySelector(".mobile-menu-head").classList.remove("active");
            }
        }, 300);
    }
}

// Close mobile menu if screen resizes
window.onresize = function () {
    if (this.innerWidth > 991 && menu.classList.contains("active")) {
        toggleMenu();
    }
};

// Add submenu icons dynamically
document.addEventListener("DOMContentLoaded", function () {
    const menuItemsWithChildren = document.querySelectorAll(".menu-item-has-children");

    menuItemsWithChildren.forEach(item => {
        const directSubMenu = Array.from(item.children).find(child => child.classList.contains("sub-menu"));
        const link = Array.from(item.children).find(child => child.tagName === "A");

        if (!directSubMenu || !link || link.nextElementSibling?.classList.contains("submenu-icon")) return;

        const submenuIcon = document.createElement("span");
        submenuIcon.classList.add("submenu-icon");
        submenuIcon.setAttribute("aria-hidden", "true");

        const icon = document.createElement("i");
        icon.classList.add("fa", "fa-angle-down");

        submenuIcon.appendChild(icon);
        link.insertAdjacentElement("afterend", submenuIcon);
    });
});







  $(document).ready(function () {
    const $searchInput = $(".col-search-box input[type='search']");
    const $searchBox = $(".serch-box-header");

    // Show box on input click
    $searchInput.on("focus", function () {
      $searchBox.show();
    });

    // Hide box on outside click
    $(document).on("click", function (e) {
      if (
        !$(e.target).closest(".col-search-box").length &&
        !$(e.target).closest(".serch-box-header").length
      ) {
        $searchBox.hide();
      }
    });
  });


  // ====================================================================
// DROPDOWN JS 
// ====================================================================

$(document).ready(function () {
    $('.dropdown').children('a').append(function () {
        return '<button type="button" class="btn expander"><i class="icon fa fa-angle-down"></i></button>';
    });

    $('.dropdown').children('ul').hide();

    $('.btn.expander').click(function () {
        $(this).parent().parent().children('ul').slideToggle();
        $(this).parent().toggleClass('current');
        $(this).find('i').toggleClass('fa-angle-up fa-angle-down');
        return false;
    });
});


/* Nava product card image switcher */
document.addEventListener('click', function (event) {
  const trigger = event.target.closest('.product-card-image-switch');
  if (!trigger) return;

  const card = trigger.closest('.box-product');
  if (!card) return;

  const mainImage = card.querySelector('.main-p-img img');
  const imageUrl = trigger.dataset.productCardImage;
  if (!mainImage || !imageUrl) return;

  event.preventDefault();

  mainImage.src = imageUrl;
  mainImage.removeAttribute('srcset');

  card.querySelectorAll('.product-card-image-switch').forEach(function (button) {
    const isActive = button === trigger;
    button.classList.toggle('active', isActive);
    button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
  });
});
